import { useEffect, useState } from "react";
import executeRequest from "../../../server/public/modules/request.js";
function getURLBase64(url) {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
            if (this.status === 200) {
                let blob = this.response;
                let fileReader = new FileReader();
                fileReader.onloadend = function (e) {
                    let result = e.target.result;
                    resolve(result);
                };
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.onerror = function () {
            reject();
        };
        xhr.send();
    });
}
export function getResourceUrl(resourceName) {
    return `/api/public/merchants/${resourceName}/load`;
}
export function useResourcesList() {
    const [resources, setResources] = useState([]);
    useEffect(() => {
        executeRequest("/api/public/merchants/listResources", "GET", {}).then((response) => {
            if (response.status == 200) {
                setResources(response.resourceLabels);
            }
        });
    }, []);
    function getResource(resourceName) {
        return new Promise((resolve) => {
            getURLBase64(`/api/public/merchants/${resourceName}/load`).then((src) => {
                const img = document.createElement("img");
                img.crossOrigin = "anonymous";
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob((blob) => {
                        const file = new File([blob], resourceName, { type: "image/png" });
                        resolve(file);
                    });
                };
                img.src = src;
            });
        });
    }
    return [resources, getResource];
}
